export default __webpack_public_path__ + "static/media/wishing-well.fddff4d5.png";